/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 15.10.25
 *
 */

import FilterableItem from "@shared/Filterable/FilterableItem";
import {FilterableProperty} from "@shared/Filterable/PropertyDecorators";

export default class BaseExtraItem extends FilterableItem {

	@FilterableProperty()
	title: string = null
	description: string = null

	lastUsedAt: number = null


	constructor(options) {
		super(options);
		this.applyOptions(options);
	}

	setLastUsedNow(){
		this.lastUsedAt = Date.now()
	}
}
